import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Col, Card, CardBody, Modal, ModalHeader, ModalBody } from 'reactstrap';
import LoadingOverlay from 'react-loading-overlay-ts';
import DNALoader from '../../components/Loaders/DnaLoader';
import Alerts from '../../components/Alerts/alerts';
import ItemsService from "./Item.service.js";

const AddStockModal = ({ showModal, handleToggleModal, onSuccess, sessionID, pharmacyID, itemId, businessId }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState({
    item_id: itemId,
    business_id: businessId,
    pharmacy_id: pharmacyID,
    quantity: "",
    price: "",
    expiry_date: "",
    status: "Active"
  });

  const [errors, setErrors] = useState({});

  const resetForm = () => {
    setData(prevData => ({
      ...prevData,
      quantity: '',
      price: '',
      expiry_date: '',
    }));
    setErrors({});
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setData({ ...data, [name]: value });
    setErrors({ ...errors, [name]: '' });
  };

  const validateForm = () => {
    const newErrors = {};
    if (!data.quantity) newErrors.quantity = 'Quantity is required';
    if (!data.price) newErrors.price = 'Price is required';
    if (!data.expiry_date) newErrors.expiry_date = 'Expiry date is required';
    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const formErrors = validateForm();
    if (Object.keys(formErrors).length > 0) {
      setErrors(formErrors);
      return;
    }

    setLoading(true);
    try {
      const response = await ItemsService.AddStock(sessionID, data);
      setLoading(false);
      if (response.data.status === true) {
        Alerts.swalSuccessAlert(t('Stock added successfully.'));
        resetForm();
        onSuccess();
        handleToggleModal();
      } else {
        Alerts.swalErrorAlert(response.data.message || t('Failed to add stock.'));
      }
    } catch (error) {
      setLoading(false);
      Alerts.swalErrorAlert(t('An error occurred. Please try again.'));
      console.error('Error adding stock:', error);
    }
  };

  return (
    <Modal isOpen={showModal} toggle={handleToggleModal}>
      <ModalHeader toggle={handleToggleModal}>{t('Add Stock')}</ModalHeader>
      <ModalBody>
        <Col md="12">
          <Card className="main-card mb-3">
            <CardBody>
              <LoadingOverlay
                active={loading}
                spinner={<DNALoader />}
              >
                <form onSubmit={handleSubmit}>
                  <div className="row">
                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Quantity')}</label>
                        <input
                          placeholder='Enter Quantity'
                          type="number"
                          className="form-control"
                          name="quantity"
                          value={data.quantity}
                          onChange={handleChange}
                        />
                        {errors.quantity && <span className="error text-danger">{errors.quantity}</span>}
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Price')}</label>
                        <input
                          placeholder='Enter Price'
                          type="number"
                          step="0.01"
                          className="form-control"
                          name="price"
                          value={data.price}
                          onChange={handleChange}
                        />
                        {errors.price && <span className="error text-danger">{errors.price}</span>}
                      </div>
                    </div>

                    <div className="col-md-12 mt-3">
                      <div className="form-group">
                        <label>{t('Expiry Date')}</label>
                        <input
                          type="date"
                          className="form-control"
                          name="expiry_date"
                          value={data.expiry_date}
                          onChange={handleChange}
                        />
                        {errors.expiry_date && <span className="error text-danger">{errors.expiry_date}</span>}
                      </div>
                    </div>
                  </div>

                  <div className="row">
                    <div className="col-md-12 text-center mt-3">
                      <button type="button" className="btn btn-outline-light btn-hover-shine me-3" onClick={handleToggleModal}>
                        {t('Close')}
                      </button>
                      <button type="submit" className="btn btn-custom-color">
                        {t('Add Stock')}
                      </button>
                    </div>
                  </div>
                </form>
              </LoadingOverlay>
            </CardBody>
          </Card>
        </Col>
      </ModalBody>
    </Modal>
  );
};

export default AddStockModal;